module.exports = __webpack_public_path__ + "media/images/quote-gold-8bca4f92038b8c2bc1f22440733ef8bb.svg";